import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ccaf7d44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-calendar-container" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = { class: "calendar-actions" }
const _hoisted_4 = {
  key: 0,
  class: "loading"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading calendar data...", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "error-message"
}
const _hoisted_8 = {
  key: 2,
  class: "calendar-content"
}
const _hoisted_9 = { class: "calendar-header" }
const _hoisted_10 = { class: "calendar-dates" }
const _hoisted_11 = { class: "calendar-details" }
const _hoisted_12 = { class: "detail-section" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Calendar Information", -1))
const _hoisted_14 = { class: "detail-row" }
const _hoisted_15 = { class: "detail-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Type", -1))
const _hoisted_17 = { class: "detail-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Status", -1))
const _hoisted_19 = {
  key: 0,
  class: "detail-item full-width"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Description", -1))
const _hoisted_21 = {
  key: 1,
  class: "detail-item full-width"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Associated Schools", -1))
const _hoisted_23 = { class: "schools-list" }
const _hoisted_24 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_25 = {
  key: 1,
  class: "no-schools"
}
const _hoisted_26 = {
  key: 2,
  class: "schools-grid"
}
const _hoisted_27 = { class: "school-card-hover" }
const _hoisted_28 = { class: "school-card-actions" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit", -1))
const _hoisted_30 = { class: "action-button" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View", -1))
const _hoisted_32 = { class: "detail-section" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Default Schedule", -1))
const _hoisted_34 = { class: "detail-row" }
const _hoisted_35 = { class: "detail-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Start Time", -1))
const _hoisted_37 = { class: "detail-item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "End Time", -1))
const _hoisted_39 = { class: "events-section" }
const _hoisted_40 = { class: "attachments-section" }
const _hoisted_41 = {
  key: 3,
  class: "modal-overlay"
}
const _hoisted_42 = { class: "modal-content" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Confirm Delete", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "warning" }, "This action cannot be undone.", -1))
const _hoisted_45 = { class: "modal-actions" }

import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import { API_URL } from "../config";
import CalendarAttachments from "../components/CalendarAttachments.vue";
import CalendarEventsView from "../components/CalendarEventsView.vue";
import { getErrorMessage } from "../types";
import type {
  CalendarEventRecord,
  CalendarRecord,
  OrganizationRecord,
} from "../types";

// Router and Route

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewCalendarView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const calendarId = Number(route.params.calendarId);

// State
const calendar = ref<CalendarRecord | Record<string, never>>({});
const loading = ref(true);
const loadingEvents = ref(false);
const error = ref("");
const showDeleteModal = ref(false);
const events = ref<CalendarEventRecord[]>([]);
const districtSchools = ref<OrganizationRecord[]>([]);
const loadingSchools = ref(false);

// Format date
const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  // Adjust for timezone offset
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(date.getTime() + userTimezoneOffset);

  return adjustedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const formatCalendarType = (type: string): string => {
  if (!type) return "N/A";
  return type.charAt(0).toUpperCase() + type.slice(1);
};

const formatStatus = (status: string): string => {
  if (!status) return "N/A";
  return status.charAt(0).toUpperCase() + status.slice(1);
};

// Fetch district schools
const fetchDistrictSchools = async () => {
  if (calendar.value?.type !== "district" || !calendar.value?.district?.id) {
    console.log("Not a district calendar or no district ID:", calendar.value);
    return;
  }

  loadingSchools.value = true;
  try {
    console.log(
      "Fetching district schools for district ID:",
      calendar.value.district.id
    );
    // Get the district with its organizations
    const response = await axios.get(
      `${API_URL}/districts/${calendar.value.district.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    console.log("District API Response:", response.data);

    // Extract schools from the organizations relation
    districtSchools.value = response.data.organizations || [];
    console.log("District schools:", districtSchools.value);
  } catch (err: unknown) {
    console.error("Error fetching district schools:", err);
  } finally {
    loadingSchools.value = false;
  }
};

// Fetch calendar data
const fetchCalendar = async () => {
  console.log("fetchCalendar called");
  loading.value = true;
  try {
    console.log("Making API request to fetch calendar:", calendarId);
    const response = await axios.get(`${API_URL}/calendar/${calendarId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    console.log("Calendar API Response:", response.data);

    calendar.value = response.data;
    console.log("Updated calendar.value:", calendar.value);

    // Fetch district schools if this is a district calendar
    if (calendar.value.type === "district") {
      console.log("Calendar is district type, fetching schools");
      await fetchDistrictSchools();
    }

    // Fetch events after getting calendar info
    console.log("Calling fetchEvents after getting calendar info");
    fetchEvents();
  } catch (err: unknown) {
    console.error("Error in fetchCalendar:", err);
    error.value = getErrorMessage(err, "Failed to fetch calendar");
    loading.value = false;
  }
};

// Fetch calendar events
const fetchEvents = async () => {
  console.log("fetchEvents called");
  loadingEvents.value = true;
  try {
    console.log("Making API request to fetch events for calendar:", calendarId);
    const response = await axios.get(
      `${API_URL}/calendar/${calendarId}/events`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    console.log("Events API Response:", response.data);

    events.value = response.data;
    loading.value = false;
  } catch (err: unknown) {
    console.error("Error in fetchEvents:", err);
    error.value = getErrorMessage(err, "Failed to fetch events");
  } finally {
    loadingEvents.value = false;
  }
};

// Navigation
const goBack = () => {
  // Check if we should return to a specific page
  const returnTo = route.query.returnTo as string;
  if (returnTo) {
    router.push(returnTo);
  } else {
    // Default: go back to calendar list
    router.push("/calendar");
  }
};

const editCalendar = () => {
  // Pass the returnTo parameter if it exists
  const returnTo = route.query.returnTo as string;
  if (returnTo) {
    router.push({
      path: `/calendar/${calendarId}/edit`,
      query: { returnTo },
    });
  } else {
    router.push(`/calendar/${calendarId}/edit`);
  }
};

const confirmDelete = () => {
  showDeleteModal.value = true;
};

const deleteCalendar = async () => {
  try {
    await axios.delete(`${API_URL}/calendar/${calendarId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    // Success message
    console.log("Calendar deleted successfully");

    // Redirect to calendar list
    router.push("/calendar");
  } catch (err: unknown) {
    console.error("Error deleting calendar:", err);
    error.value = getErrorMessage(err, "Failed to delete calendar");
  }
};

// Lifecycle hooks
onMounted(() => {
  console.log("ViewCalendarView component mounted");
  console.log("calendarId:", calendarId);
  fetchCalendar();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-back",
        onClick: goBack
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "arrow-left" }),
        _createTextVNode(" Back to Calendars ")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: `/calendar/${_unref(calendarId)}/events/add`,
          class: "btn-add"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FontAwesomeIcon), { icon: "plus" }),
            _createTextVNode(" Add Event ")
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("button", {
          class: "btn-edit",
          onClick: editCalendar
        }, [
          _createVNode(_unref(FontAwesomeIcon), { icon: "edit" }),
          _createTextVNode(" Edit Calendar ")
        ]),
        _createElementVNode("button", {
          class: "btn-delete",
          onClick: confirmDelete
        }, [
          _createVNode(_unref(FontAwesomeIcon), { icon: "trash" }),
          _createTextVNode(" Delete Calendar ")
        ])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(error.value), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h1", null, _toDisplayString(calendar.value.name), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(formatDate(calendar.value.startDate)) + " - " + _toDisplayString(formatDate(calendar.value.endDate)), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("p", null, _toDisplayString(formatCalendarType(calendar.value.type)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("p", null, _toDisplayString(formatStatus(calendar.value.status)), 1)
                  ])
                ]),
                (calendar.value.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("p", null, _toDisplayString(calendar.value.description), 1)
                    ]))
                  : _createCommentVNode("", true),
                (calendar.value.type === 'district' && calendar.value.district)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        (loadingSchools.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Loading schools... "))
                          : (districtSchools.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, " No schools associated with this district. "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(districtSchools.value, (school) => {
                                  return (_openBlock(), _createBlock(_component_router_link, {
                                    key: school.id,
                                    to: `/organizations/${school.id}`,
                                    class: "school-card"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, _toDisplayString(school.name), 1),
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                          _createVNode(_component_router_link, {
                                            to: `/organizations/${school.id}/edit`,
                                            class: "action-button",
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(FontAwesomeIcon), { icon: "edit" }),
                                              _hoisted_29
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]),
                                          _createElementVNode("div", _hoisted_30, [
                                            _createVNode(_unref(FontAwesomeIcon), { icon: "eye" }),
                                            _hoisted_31
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                }), 128))
                              ]))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("p", null, _toDisplayString(calendar.value.defaultStartTime || "Not set"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("p", null, _toDisplayString(calendar.value.defaultEndTime || "Not set"), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(CalendarEventsView, { calendarId: _unref(calendarId) }, null, 8, ["calendarId"])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(CalendarAttachments, { calendarId: _unref(calendarId) }, null, 8, ["calendarId"])
            ])
          ])),
    (showDeleteModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("p", null, " Are you sure you want to delete the calendar \"" + _toDisplayString(calendar.value.name) + "\"? ", 1),
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showDeleteModal.value = false))
              }, " Cancel "),
              _createElementVNode("button", {
                class: "btn-confirm-delete",
                onClick: deleteCalendar
              }, " Delete ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})